import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from '../../core/api/endpoints';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VoucherProgramService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  getAllVoucherPrograms(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.voucherProgram.base}`
    );
  }

  getVoucherProgramById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.voucherProgram.base}/${Endpoints.voucherProgram.getById(id)}`
    );
  }

  createVoucherProgram(voucherProgram: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.voucherProgram.base}`, voucherProgram);
  }

  updateVoucherProgram(id: number, voucherProgram: any): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${Endpoints.voucherProgram.base}/${Endpoints.voucherProgram.update(id)}`, voucherProgram);
  }

   deleteVoucherProgram(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${Endpoints.voucherProgram.base}/${Endpoints.voucherProgram.delete(id)}`);
  }
}
